import {
  addJourneyMessages,
  sleep,
} from "../../../../helpers/addJourneyMessages";
import createMessage from "../../../../helpers/createMessage";
import { createGeneralEnquiry } from "../../../../actions/cowrapperapi";
import {
  updateApiProgress,
  clearApiProgress,
} from "../../../../actions/flowWindow";
import {
  API_PROGRESS,
  COMPONENTS,
  ACTIVITY,
} from "../../../../helpers/constants";
import { udpateChatInputVisibility } from "../../../Appsync/state/operators";
import updateVisitor from "../../../Appsync/updateVisitor";
import { setChatReason } from "../../../Appsync/state/reducers";
import Config from "../../../Appsync/Config";

export const helpNeededForInquiry = (helpNeeded, textPrint) => (dispatch) => {
  dispatch(addJourneyMessages([createMessage("TEXT", "user", textPrint)]));
  const isHelpNeeded = helpNeeded === "Yes";
  if (isHelpNeeded) {
    // dispatch(
    //   addJourneyMessages([
    //     createMessage("GENERAL_ENQUIRY", "system", {
    //       showComponent: "IsExistingCustomer",
    //     }),
    //   ])
    // );
    dispatch(
      addJourneyMessages([
        createMessage("TEXT", "system", {
          key: "SystemMessage.ProvideEnquiryDetails",
        }),
        createMessage("GENERAL_ENQUIRY", "system", {
          showComponent: "ProvideEnquiryDetails",
        }),
      ])
    );
  } else {
    dispatch(
      addJourneyMessages([createMessage("ENQUIRY_OPTIONS", "system", {})])
    );
  }
};

export const checkIsExistingCustomer = (status) => (dispatch) => {
  dispatch(addJourneyMessages([createMessage("TEXT", "user", status)]));
  const isExistingCustomer = status === "Yes";
  if (isExistingCustomer) {
    dispatch(
      addJourneyMessages([
        createMessage("TEXT", "system", {
          key: "SystemMessage.ProvideEnquiryDetails",
        }),
        createMessage("GENERAL_ENQUIRY", "system", {
          showComponent: "ProvideEnquiryDetails",
        }),
      ])
    );
  } else {
    dispatch(
      addJourneyMessages([
        createMessage("TEXT", "system", {
          key: "SystemMessage.OnlyRegisteredCustomer",
        }),
        createMessage("ENQUIRY_OPTIONS", "system", {}),
      ])
    );
  }
};

export const saveEnquiryDetails = (note) => async (dispatch, getStore) => {
  dispatch(addJourneyMessages([createMessage("TEXT", "user", note)]));
  const client = getStore().app.client;
  const clientName = Config[client].Carrier.Client;
  const country = Config[client].Carrier.Country;
  const component = COMPONENTS.CREATE_ENQUIRY;
  const module = API_PROGRESS.CREATE_ENQUIRY;
  const module_success = API_PROGRESS.CREATE_ENQUIRY_SUCCESS;
  await dispatch(updateApiProgress(module, 40, component));
  const langCode = getStore().session.interactionData.Interaction.SessionData
    .LanguageCode;
  await dispatch(createGeneralEnquiry(clientName, country, langCode, note));
  dispatch(updateVisitor({ lastActivity: ACTIVITY.CREATE_ENQUIRY }));
  await dispatch(updateApiProgress(module_success, 100, component, 40));
  await sleep(1000);
  await dispatch(clearApiProgress());
  await dispatch(setChatReason("General Inquiry"));
  dispatch(udpateChatInputVisibility(true));
};
